import {inject, injectable} from 'inversify';

import {AudioModelFactory} from '../../../core/models/Audio/AudioModel.factory';
import {AudioPlayerState} from './AudioPlayerState';

@injectable()
export class AudioPlayerStateFactory {
  constructor(
    @inject(AudioModelFactory)
    private readonly audioModelFactory: AudioModelFactory,
  ) {}

  create(props: AudioPlayerState.Props) {
    return new AudioPlayerState(props, this.audioModelFactory);
  }
}
